import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bc0e869"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_2 = { class: "modal-content bg-light rounded-card px-3 px-sm-4" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close bg-info text-light rounded-pill px-3 opacity-100",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_6 = { class: "modal-body row d-flex align-self-stretch" }
const _hoisted_7 = {
  id: "pills-tab",
  class: "nav nav-pills d-flex justify-content-around justify-content-sm-start col-12 col-sm-2 p-0",
  role: "tablist"
}
const _hoisted_8 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_9 = {
  id: "pills-tabContent",
  class: "tab-content col my-auto"
}
const _hoisted_10 = ["id", "aria-labelledby"]

import { ref, onMounted } from "vue";
import MyProfile from "@/components/modal-components/my-profile-modal/MyProfile.vue";
import UpdateProfile from "@/components/modal-components/my-profile-modal/UpdateProfile.vue";
import ChangePassword from "@/components/modal-components/my-profile-modal/ChangePassword.vue";


const __default__ = {
  name: "MyProfileModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const title = ref<string>();
const profileModal = ref();
const navPillsData = [
  {
    title: "My Profile",
    icon: "fa-user-circle-o",
  },
  {
    title: "Change Password",
    icon: "fa-lock",
  },
  {
    title: "Update Profile",
    icon: "fa-pencil",
  },
];

onMounted(() => {
  profileModal.value.addEventListener(
    "show.bs.modal",
    (event: {
      relatedTarget: { getAttribute: (arg0: string) => string | undefined };
    }) => {
      title.value = event.relatedTarget.getAttribute("data-bs-title");
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "profileModal",
    ref: profileModal,
    class: "modal fade",
    id: "myProfileModal",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    "data-bs-touch": "false",
    "data-bs-interval": "false"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(title.value), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navPillsData, (data, i) => {
              return _createElementVNode("li", {
                key: i,
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("div", {
                  id: 'data-' + i + '-tab',
                  "data-bs-toggle": "pill",
                  "data-bs-target": '#' + 'data-' + i,
                  role: "tab",
                  type: "button",
                  "aria-controls": 'data-' + i,
                  "aria-selected": "true",
                  class: _normalizeClass(["nav-link border border-2 btn d-flex align-items-center justify-content-center rounded-4 bg-light my-1 text-secondary card-dimensions p-0", { active: i === 0 }])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa fa-2x", data.icon]),
                    "aria-hidden": "true"
                  }, null, 2)
                ], 10, _hoisted_8)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navPillsData, (data, i) => {
              return _createElementVNode("div", {
                key: i,
                id: 'data-' + i,
                class: _normalizeClass(["tab-pane fade show", { active: i === 0 }]),
                role: "tabpanel",
                "aria-labelledby": 'data-' + i + '-tab'
              }, [
                (data.title === 'My Profile')
                  ? (_openBlock(), _createBlock(MyProfile, { key: 0 }))
                  : _createCommentVNode("", true),
                (data.title === 'Change Password')
                  ? (_openBlock(), _createBlock(ChangePassword, { key: 1 }))
                  : _createCommentVNode("", true),
                (data.title === 'Update Profile')
                  ? (_openBlock(), _createBlock(UpdateProfile, { key: 2 }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_10)
            }), 64))
          ])
        ])
      ])
    ])
  ], 512))
}
}

})